import { Base64 } from 'js-base64';
// export const storageData = {
//   storage: {
//     token_key: Base64.encode('USER_TOKEN'),
//     user_info: 'USER_INFO'
//   },

//   /* 登录成功 token 存储 */
//   setToken(token) {
//     this.clearToken();
//     const xToken = Base64.encode(token);
//     localStorage.setItem(this.storage.token_key, xToken);
//   },
//   getToken() {
//     const xToken = localStorage.getItem(this.storage.token_key);
//     if (xToken) {
//       return Base64.decode(xToken);
//     }
//     return false;
//   },
//   clearToken() {
//     localStorage.removeItem(this.storage.token_key);
//   },
// //   用户信息
//   setUserInfo(userInfo) {
//     console.log({
//       USERINFO: this.storage.user_info,
//       info: userInfo
//     })
//     localStorage.setItem(this.storage.user_info, JSON.stringify(userInfo));
//   },
//   getUserInfo() {
//     const userInfo = localStorage.getItem(this.storage.user_info);
//     if (userInfo) {
//       return JSON.parse(userInfo);
//     }
//     return false;
//   },
//   clearUserInfo() {
//     localStorage.removeItem(this.storage.user_info);
//   },
// };


class StorageData {
  constructor () {
    this.storage = {
      token_key: Base64.encode('USER_TOKEN'),
      user_info: 'USER_INFO'
    }
  }

  /* 登录成功 token 存储 */
  setToken(token) {
    this.clearToken();
    const xToken = Base64.encode(token);
    localStorage.setItem(this.storage.token_key, xToken);
  }
  getToken() {
    const xToken = localStorage.getItem(this.storage.token_key);
    if (xToken) {
      return Base64.decode(xToken);
    }
    return false;
  }

  clearToken() {
    localStorage.removeItem(this.storage.token_key);
  }

//   用户信息
  setUserInfo(userInfo) {
    console.log({
      USERINFO: this.storage.user_info,
      info: userInfo
    })
    localStorage.setItem('loginUserInfo', JSON.stringify(userInfo));
  }

  getUserInfo() {
    const userInfo = localStorage.getItem('loginUserInfo');
    if (userInfo) {
      return JSON.parse(userInfo);
    }
    return false;
  }

  clearUserInfo() {
    localStorage.removeItem(this.storage.user_info);
  }
}

export const storageData = new StorageData()



// WEBPACK FOOTER //
// ./src/assets/js/storage.js